const articles = [
  {
    id: 1,
    title: 'Excerpts from a passionate developer',
    url: 'https://medium.com/@duanedave19/excerpts-from-a-passionate-developer-what-i-have-learned-and-how-it-can-help-you-become-a-better-344b257b9469',
    image: 'https://miro.medium.com/v2/resize:fit:640/format:webp/1*docc5LX0tMwwiBWWTIsiXA.jpeg',
  },
];

export default articles;
